import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'provider-photo',
  imports: [
    CommonModule
  ],
  templateUrl: './provider-photo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./provider-photo.component.scss']
})
export class ProviderPhotoComponent {
  readonly initials = input<string | undefined, string>('', {
    transform: (v) => v ?? ''
  });
  readonly photoUrl = input<string | undefined, string>('', {
    transform: (v) => (!v || v?.includes('missing.png') ? '' : v)
  });
  readonly providerName = input<string | undefined, string>('', {
    transform: (v) => v ?? ''
  });
}
